import React from 'react';
import './Alert.css';

const Alert = ({ type = 'danger', title, message, show }) => {
  if (!show) return null;

  const icon = type === 'success' ? '✓' : '⚠️';

  return (
    <div className={`alert alert-${type}`}>
      <span className="alert-icon">{icon}</span>
      <div className="alert-content">
        <div className="alert-title">{title}</div>
        <div className="alert-message">{message}</div>
      </div>
    </div>
  );
};

export default Alert;
